import { render, staticRenderFns } from "./ElementStudioControls.vue?vue&type=template&id=6d9d4333&"
import script from "./ElementStudioControls.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports